/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { useEffect, useState } from "react";
import { Button, Checkbox, Dropdown, Input, Segment, Table } from "semantic-ui-react";
import AlertModal from "./AlertModal";
import TextareaAutosize from 'react-textarea-autosize';
import convertRIStoFHIR from "../functions/convertRIStoFHIR";
import RIStoFHIRConversionForm from "./RIStoFHIRConversionForm";
import { changeTool } from "../slices/footer/footerSlice";

// eslint-disable-next-line no-empty-pattern
const RIStoFEvIRConverterPage = ({ }) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);

    const [risEntryState, setRisEntryState] = useState({
        "inputChanged": true,
        "codings": [{ "systemName": "", "systemUri": "", "code": "", "display": "", "qualifiers": [], "preset": "" }],
        text: "",
        risFile: ""
    });
    const [risMappingState, setRisMappingState] = useState([]);
    const [fhirOutputState, setFhirOutputState] = useState("");

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR RIS-to-FEvIR Converter"));
        dispatch(changeTool("Computable Publishing®: RIS-to-FEvIR Converter"));
    }, []);

    return (
        <div>
            <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                <RIStoFHIRConversionForm risEntryState={risEntryState} setRisEntryState={setRisEntryState}
                    risMappingState={risMappingState} setRisMappingState={setRisMappingState} />
                <br />
                <Button className="formButton positive" content="Convert RIS to FEvIR" compact
                    onClick={() => { convertRIStoFHIR(apiToken, risEntryState, risMappingState, setFhirOutputState); }}
                    disabled={risMappingState.length === 0 ? true : false} />
                <br />
                {
                    fhirOutputState &&
                    <Button className="formButton" content="Copy JSON" compact
                        onClick={() => { navigator.clipboard.writeText(fhirOutputState); }}
                        disabled={!fhirOutputState ? true : false} />
                }
                <h3>JSON Output</h3>
                <TextareaAutosize style={{ width: "98%", color: "#000000" }}
                    spellCheck="false"
                    value={fhirOutputState} />
                <br /><br />
                {
                    fhirOutputState &&
                    <Button className="formButton" content="Copy JSON" compact
                        onClick={() => { navigator.clipboard.writeText(fhirOutputState); }}
                        disabled={!fhirOutputState ? true : false} />
                }
            </Segment>
        </div>
    );
};

export default RIStoFEvIRConverterPage;